import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { formatStatus, getStatusColor } from '@ubus/shared';

export interface StatusTagProps {
  status: string;
  /** Override Ant Design tag color */
  color?: string;
  /** Override display label (e.g. job scheduled → Published) */
  label?: string;
}

/** Consistent status pill using shared formatters and traffic-light semantics. */
export function StatusTag({ status, color, label }: StatusTagProps) {
  const { t } = useTranslation();
  const display =
    label ?? t(`statuses.${status}`, { defaultValue: formatStatus(status) });
  return (
    <Tag color={color ?? getStatusColor(status)} className="admin-status-tag">
      {display}
    </Tag>
  );
}

export default StatusTag;
